/* eslint pinterest/no-jquery-outside-of-render:0 */
// vendor libs
import debounce from 'lodash/debounce';
import BackboneEventsShim from 'app/common/lib/BackboneEventsShim';


// Module dependencies
import BodyColumns from 'app/common/lib/BodyColumns';

/**
 * Global Viewport Manager
 *
 * Triggers PCONST.EVENT_RESIZE event on window resize, after debouncing
 *
 * @constructor
 */
const Viewport = function () {
  this.height = 0;
  this.width = 0;
};

Object.assign(Viewport.prototype, /** @lends {Viewport.prototype} */ {
  init() {
    this.on(PCONST.EVENT_RESIZE, this._onResize, this);
    window.addEventListener('resize', debounce(
      this._cacheWindowSize.bind(this), 200,
    ));
    this._cacheWindowSize();
    this.updateBodyColumns();
  },

  _cacheWindowSize() {
    const newHeight = document.documentElement.clientHeight;
    const newWidth = document.documentElement.clientWidth;

    if (newHeight !== this.height || newWidth !== this.width) {
      this.height = newHeight;
      this.width = newWidth;
      this.trigger(PCONST.EVENT_RESIZE);
    }
  },

  _onResize() {
    this.updateBodyColumns();
  },

  updateBodyColumns() {
    this.setBodyColumns(BodyColumns.getBodyColumnsNeeded());
  },

  setBodyColumns(numColumns) {
    if (numColumns === this.numColumns) {
      return;
    }

    this.numColumns = numColumns;
    BodyColumns.setNumColumns(numColumns);
    this.trigger(PCONST.EVENT_BODY_COLUMN_CHANGE);
  },
});

const viewportInstance = new Viewport();
Object.assign(viewportInstance, /** @lends {Viewport} */ BackboneEventsShim);

export default viewportInstance;
